import { DatePicker, Icon, Input, Label, Modal } from '@components';
import { ValidationError } from '@types';
import { formatISODate } from '@utils/date';

import theme from '../../../../../../themes/colors';

interface GroupEndDateSelectionProps {
  formData: any;
  onClearEndDate: () => void;
  setIsEndDateModalOpen: (value: boolean) => void;
  isEndDateModalOpen: boolean;
  onEndDateChange: (date: string) => void;
  endDateMinDate: () => Date;
  endDateSelectedDate: () => Date;
  isEndDateDisabled: boolean;
  groupEndDateClassName: string;
  labelClassName?: string;
  error?: ValidationError;
}

const GroupEndDateSelection = ({
  formData,
  onClearEndDate,
  setIsEndDateModalOpen,
  isEndDateModalOpen,
  onEndDateChange,
  endDateMinDate,
  endDateSelectedDate,
  isEndDateDisabled,
  groupEndDateClassName,
  error = { endDate: '' },
  labelClassName = '!mb-2'
}: GroupEndDateSelectionProps) => (
  <>
    <div className={`w-full md:w-1/2 lg:w-1/3 ${groupEndDateClassName}`}>
      <Label
        label="Group Deactivation Date"
        className={`!text-content ${labelClassName}`}
      />

      <Input
        onClearIconAction={onClearEndDate}
        readOnly
        leftIconName="calendar"
        value={
          formData.endDate ? formatISODate({ date: formData.endDate }) : ''
        }
        onClick={() => {
          setIsEndDateModalOpen(true);
        }}
        placeholder="Select payment end day"
        error={!!error.endDate}
        errorMessage={error.endDate}
        className={`${isEndDateDisabled ? 'text-grey' : ''}`}
        disabled={isEndDateDisabled}
        inputStyle="!bg-theme"
      />
      <div
        className={`my-1 flex gap-1 text-sm text-grey60 ${
          error.endDate ? 'mt-6' : ''
        }`}
      >
        <Icon
          name="alert-circle"
          stroke={theme.subText}
          size="16"
          className="mt-0.25 !min-w-4"
        />
        Group will be deactivated and payment links will not be sent after this
        date. All previously sent payment links will continue to work.
      </div>
    </div>
    {isEndDateModalOpen && (
      <Modal
        isOpen={isEndDateModalOpen}
        onCancel={() => setIsEndDateModalOpen(false)}
      >
        <DatePicker
          confirmButtonLabel="Apply"
          confirmButtonStyle="text-primary"
          handleConfirm={onEndDateChange}
          cancelButtonLabel="Cancel"
          handleCancel={() => {
            setIsEndDateModalOpen(false);
          }}
          minDate={endDateMinDate()}
          selectedDate={endDateSelectedDate()}
          calendarStyle="!bg-bgBase"
        />
      </Modal>
    )}
  </>
);

export default GroupEndDateSelection;
